const ARROW_DOTS_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor">
	<circle cx="5" cy="5" r="3.6" style="--off:4"/>
	<circle cx="15" cy="5" r="3.6" style="--off:0"/>
	<circle cx="25" cy="5" r="3.6" style="--off:1"/>
	<circle cx="35" cy="5" r="3.6" style="--off:2"/>
	<circle cx="45" cy="5" r="3.6" style="--off:3"/>
	<circle cx="5" cy="15" r="3.6" style="--off:3"/>
	<circle cx="15" cy="15" r="3.6" style="--off:4"/>
	<circle cx="25" cy="15" r="3.6" style="--off:0"/>
	<circle cx="35" cy="15" r="3.6" style="--off:1"/>
	<circle cx="45" cy="15" r="3.6" style="--off:2"/>
	<circle cx="5" cy="25" r="3.6" style="--off:2"/>
	<circle cx="15" cy="25" r="3.6" style="--off:3"/>
	<circle cx="25" cy="25" r="3.6" style="--off:4"/>
	<circle cx="35" cy="25" r="3.6" style="--off:0"/>
	<circle cx="45" cy="25" r="3.6" style="--off:1"/>
	<circle cx="5" cy="35" r="3.6" style="--off:3"/>
	<circle cx="15" cy="35" r="3.6" style="--off:4"/>
	<circle cx="25" cy="35" r="3.6" style="--off:0"/>
	<circle cx="35" cy="35" r="3.6" style="--off:1"/>
	<circle cx="45" cy="35" r="3.6" style="--off:2"/>
	<circle cx="5" cy="45" r="3.6" style="--off:4"/>
	<circle cx="15" cy="45" r="3.6" style="--off:0"/>
	<circle cx="25" cy="45" r="3.6" style="--off:1"/>
	<circle cx="35" cy="45" r="3.6" style="--off:2"/>
	<circle cx="45" cy="45" r="3.6" style="--off:3"/>
</svg>`;

export default class Buttons {
	constructor() {
		this.buttons = document.querySelectorAll(".btn:not(.btn-processed)");

		this.buttons.forEach((button) => {
			button.classList.add("btn-processed");
			button.innerHTML = `<span class="label">${button.innerHTML}</span>`;

			const arrowEnd = document.createElement("span");
			arrowEnd.className = "btn-arrow-dots btn-arrow-dots-end";
			arrowEnd.setAttribute("aria-hidden", "true");
			arrowEnd.innerHTML = ARROW_DOTS_SVG;
			button.appendChild(arrowEnd);
		});
	}
}
